import { render, staticRenderFns } from "./prechargeMgt.vue?vue&type=template&id=6ccf8640&scoped=true&"
import script from "./prechargeMgt.vue?vue&type=script&lang=js&"
export * from "./prechargeMgt.vue?vue&type=script&lang=js&"
import style0 from "./prechargeMgt.vue?vue&type=style&index=0&id=6ccf8640&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf8640",
  null
  
)

export default component.exports